const BreadCrumbIcon = ({ ...props }: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      viewBox="0 0 12 12" // Add the viewBox attribute
      width={16} // Double the size
      height={16}
    >
      <path stroke="#231F20" strokeLinecap="round" strokeLinejoin="round" d="M8 9 5 6l3-3" />
    </svg>
  )
}

export default BreadCrumbIcon
